(function () {
  'use strict';

  function initTabs(root) {
    var tabs = root.querySelectorAll('.clinical-trial-tab');
    var panels = root.querySelectorAll('.clinical-trial-panel');
    if (!tabs.length || !panels.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabId = tab.getAttribute('data-clinical-tab');
        tabs.forEach(function (t) {
          t.classList.remove('active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          if (p.getAttribute('data-clinical-panel') === tabId) {
            p.classList.remove('hidden');
          } else {
            p.classList.add('hidden');
          }
        });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
      });
    });
  }

  function initSlider(container) {
    var clip = container.querySelector('[data-slider-before-clip]');
    var handle = container.querySelector('[data-slider-handle]');
    var beforeInner = container.querySelector('.clinical-trial-slider-before');
    if (!clip || !handle) return;

    var containerRect = function () { return container.getBoundingClientRect(); };
    var getPercent = function (clientX) {
      var rect = containerRect();
      var x = clientX - rect.left;
      var pct = (x / rect.width) * 100;
      return Math.max(0, Math.min(100, pct));
    };

    var lineEl = container.querySelector('[data-slider-line]');

    var setPosition = function (pct) {
      clip.style.width = pct + '%';
      handle.style.left = pct + '%';
      if (lineEl) lineEl.style.left = pct + '%';
      handle.setAttribute('aria-valuenow', Math.round(pct));
      if (beforeInner) {
        beforeInner.style.width = pct > 0 ? (100 / pct * 100) + '%' : '100%';
      }
    };

    var onMove = function (clientX) {
      setPosition(getPercent(clientX));
    };

    var onPointerDown = function (e) {
      e.preventDefault();
      onMove(e.clientX);
      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
      if (handle.setPointerCapture) handle.setPointerCapture(e.pointerId);
    };

    var onPointerMove = function (e) {
      onMove(e.clientX);
    };

    var onPointerUp = function () {
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
    };

    handle.addEventListener('pointerdown', onPointerDown);

    container.addEventListener('pointerdown', function (e) {
      if (e.target === handle || handle.contains(e.target)) return;
      e.preventDefault();
      onMove(e.clientX);
      document.addEventListener('pointermove', onPointerMove);
      document.addEventListener('pointerup', onPointerUp);
      try { container.setPointerCapture(e.pointerId); } catch (err) {}
    });

    handle.addEventListener('keydown', function (e) {
      var step = 5;
      var current = parseFloat(clip.style.width || '50', 10);
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        setPosition(Math.max(0, current - step));
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        setPosition(Math.min(100, current + step));
      }
    });

    setPosition(50);
  }

  function initSliders(root) {
    var wrappers = root.querySelectorAll('[data-clinical-slider]');
    wrappers.forEach(function (wrapper) {
      var container = wrapper.querySelector('[data-slider-container]');
      if (container) initSlider(container);
    });
  }

  window.ClinicalTrialInit = function (root) {
    if (!root || !root.classList.contains('clinical-trial')) return;
    initTabs(root);
    initSliders(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.clinical-trial').forEach(window.ClinicalTrialInit);
    });
  } else {
    document.querySelectorAll('.clinical-trial').forEach(window.ClinicalTrialInit);
  }
})();
